import React from 'react';
import { useParams } from 'react-router-dom';
//import { useHttpClient } from '../shared/hooks/http-hook';
//import ErrorModal from '../shared/components/UIElements/ErrorModal';
//import LoadingSpinner from '../shared/components/UIElements/LoadingSpinner';
import './Success.css';

const Success = () => {
    const plan = useParams().plan;
    const userId = useParams().userId;
    
    /*
    const [userName, setUserName] = useState();
    const { isLoading, error, sendRequest, clearError } = useHttpClient();

    useEffect(()=>{
        const getProfile = async() => {
            try {
                const response = await sendRequest(
                    `https://api.line.me/v2/bot/profile/${line_id}`, 
                    'cors',
                    'GET', 
                    null, 
                    {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${process.env.LINE_ACCESS_TOKEN}`
                    }
                    );

                setUserName(response.displayName);
            } catch (err) {
                console.log(err);
            }
            
        };

        getProfile();
    },[line_id, sendRequest]);

    */

    return (
        <React.Fragment>
        {userId &&
        <div className='success'>
            <div className="voxy-success">VACE.AI</div>
            <div className='b-success'>
                <b>{`Welcome!`}</b>
            </div>
            {(plan === 'pro') && 
            <div className='ai-success'>
                You are successfully subscribed to Pro plan. 
            </div>
            }
            {(plan === 'ten') && 
            <div className='ai-success'>
                You successfully purchased 10 feedback pack.
            </div>
            }
        </div>
        }
        </React.Fragment>
    );
};

export default Success;